module.exports = __webpack_public_path__ + "static/media/tally.12c857f1.svg";